<template>
    <div class="card mb-3">
        <div class="card-body">
            <Loading v-if="showLoading" />
            <form class="row" v-on:submit.prevent="searchCard">
                <div class="col-md-4">
                    <div class="form-group">
                        <label>شماره پن</label>
                        <input type="text" class="form-control text-center" v-model="pan" v-mask="'####-####-####-####'">
                    </div>
                </div>
                <div class="col-md-2">
                    <button class="btn btn-success btn-block" style="margin-top: 29px;">دریافت اطلاعات</button>
                </div>
            </form>
            <hr v-if="Object.keys(cardDetails).length">
            <p v-if="Object.keys(cardDetails).length">اطلاعات کارت</p>
            <div class="table-responsive" v-if="Object.keys(cardDetails).length">
                <table class="table table-bordered table-hover mb-0">
                    <tbody>
                        <tr>
                            <td>شماره کارت:</td>
                            <td>{{ pan }}</td>
                        </tr>
                        <tr>
                            <td>مبلغ موجودی:</td>
                            <td>{{ new Intl.NumberFormat('en-IR', {maximumSignificantDigits: 20}).format(500000) }} ریال</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CardDeposit',
        data(){
            return {
                showLoading: false,
                pan: '',
                cardDetails: {}
            }
        },
        methods: {
            searchCard(){
                this.showLoading = true;
                this.$api.post('',{cardNumber: this.pan}).then(({data}) => {
                    if(data.status)
                        console.log('ok');
                }).finally(() => {
                    this.showLoading = false;
                });
            }
        }
    }
</script>